import { gql } from "@apollo/client";
import { captureException } from "@sentry/browser";
import { AppState } from "../reducers";
import {
  CONTACT_FORM_ERROR,
  CONTACT_FORM_SUCCESS,
  CONTACT_FORM_LOADING,
  APP_LOADING_START,
  APP_LOADING_END,
} from "./types";
import { apollo, AppDispatch, AppThunk, formHandleInput } from "./index";
import { addToast } from "./toast";
import type { TranslateOptions } from "@/i18n";
import { translateMessage } from "@/helpers/translation";

const translateContactMessage = (key: string, options?: TranslateOptions) =>
  translateMessage(`contact.${key}`, options);

export const sendContact = (): any => async (dispatch: AppDispatch, getState: () => AppState) => {
  try {
    dispatch({ type: CONTACT_FORM_LOADING });
    dispatch({ type: APP_LOADING_START });

    const {
      form: {
        contact: { message },
      },
      auth: {
        user: { firstname, lastname, email },
      },
    } = getState();

    const utm = {};

    await apollo().mutate<any>({
      variables: { message, name: `${firstname} ${lastname}`, email, utm },
      mutation: gql`
        mutation ($message: String!, $name: String!, $email: String!, $utm: UTMInput!) {
          addContact(message: $message, name: $name, email: $email, utm: $utm)
        }
      `,
    });

    dispatch({ type: CONTACT_FORM_SUCCESS });
    dispatch(
      addToast({
        message: translateContactMessage("success", {
          defaultValue: "Votre message a bien été envoyé",
        }),
        type: "success",
      }),
    );
    dispatch(formHandleInput("contact", "message", ""));
    dispatch({ type: APP_LOADING_END });
  } catch (err) {
    captureException(err);
    dispatch(
      addToast({
        title: "Oups !",
        message: translateContactMessage("error", {
          defaultValue:
            "Une erreur est survenue. Nous n'avons pas pu envoyer votre message. Veuillez réessayer plus tard",
        }),
        type: "error",
      }),
    );
    dispatch({ type: CONTACT_FORM_ERROR });
    dispatch({ type: APP_LOADING_END });
  }
};
